export default __webpack_public_path__ + "assets/profile_picture.jpg";